<template>
  <div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              modalWidth="80%"
              ref="master"
              :parentData="parentData"
              @action="masterActions"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-tabs>
          <a-tab-pane key="1" force-render>
                <span slot="tab">
                  <a-icon type="bulb"/>
                  Información básica
                </span>
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Nombre')">
                  <a-input
                    v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Capacidad')">
                  <a-input-number
                    style="width: 100%"
                    :min="0"
                    v-decorator="['capacity', { rules: [{ required: false}] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-lookup :label="$t('Solicitado por')"
                          :formItemConfig="fiOptions"
                          endpoint="empleados"
                          :decorator="['requested_by', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                          ref="requested_by"
                >
                </g-lookup>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown :label="$t('Centro de costo')"
                            endpoint="cc"
                            :rowKey="'id'"
                            :columns="columnasCentroCosto"
                            :saveValue="'id'"
                            :hasMultipleRows="true"
                            @model="modeloRecibido"
                            :formItemConfig="fiOptions"
                            :decorator="['id_cc', { rules: [{ required: false, message: 'Valor requerido' }]}]">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Objetivos')" v-bind="fiOptions">
                  <a-textarea autoSize
                              v-decorator="['objectives', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Observación')" v-bind="fiOptions">
                  <a-textarea autoSize
                              v-decorator="['observation', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Tipo de capacitación')"
                            :formItemConfig="fiOptions"
                            :decorator="['training_type', { rules: [{ required: false}] }]"
                            :params="training_type">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <g-dropdown endpoint="hierarchy_lookup"
                            style="width: 100%"
                            :label="$t('Tipo de asistencia')"
                            :formItemConfig="fiOptions"
                            :decorator="['assistence_type', { rules: [{ required: false}] }]"
                            :params="assistence_type">
                </g-dropdown>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Modalidad')">
                  <a-input
                    v-decorator="['modality', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Prioridad')">
                  <a-input
                    v-decorator="['priority', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Lugar')">
                  <a-input
                    v-decorator="['place', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Requerimientos')" v-bind="fiOptions">
                  <a-textarea autoSize
                              v-decorator="['requirements', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('URL')" v-bind="fiOptions">
                  <a-textarea autoSize
                              v-decorator="['url', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Nota aprobatoria')">
                  <a-input-number
                    style="width: 100%"
                    :min="0"
                    v-decorator="['passing_note', { rules: [{ required: false}] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Asistencia aprobatoria')">
                  <a-input-number
                    :min="0"
                    style="width: 100%"
                    v-decorator="['passing_assistance', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
                </a-form-item>
              </a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane key="2" force-render>
                <span slot="tab">
                  <a-icon type="calendar"/>
                  Información de fechas
                </span>
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha solicitud')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['request_date', { rules: [{ required: true, message: 'Valor requerido'}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Total días')">
                  <a-input-number
                    style="width: 100%"
                    :min="0"
                    v-decorator="['total_days', { rules: [{ required: false}] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Horas totales')">
                  <a-input-number
                    style="width: 100%"
                    :min="0"
                    v-decorator="['total_hours', { rules: [{ required: false}] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha inicio')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['init_date', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Hora inicio')" v-bind="fiOptions">
                  <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                                 v-decorator="['start_time', {type:'object', rules: [{ required: false, message: 'Valor requerido' }] }]"
                                 placeholder="H. Inicio"
                                 style="width: 100%"
                  ></a-time-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha fin')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['end_date', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item :label="$t('Hora fin')" v-bind="fiOptions">
                  <a-time-picker :minuteStep="15" use12Hours format="h:mm a"
                                 v-decorator="['end_time', {type:'object', rules: [{ required: false, message: 'Valor requerido' }] }]"
                                 placeholder="H. Fin"
                                 style="width: 100%"
                  ></a-time-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha vencimiento')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD HH:mm:ss"
                                 v-decorator="['expiration_date', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                  ></a-date-picker>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Notificaciones')" :has-feedback="false">
                  <a-checkbox
                    v-decorator="['notification', {valuePropName: 'checked' }]">
                  </a-checkbox>
                </a-form-item>
              </a-col>
            </a-row>
          </a-tab-pane>
        </a-tabs>
      </template>
    </g-master>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="Resumen capacitación" key="1">
        <template v-if="rowSelected" >
          <g-descriptions-detail :detalle="rowSelected" :valoresExpandidos="valoresExpandidos"/>
          <a-affix :offset-bottom="10">
            <a-card style="text-align: right" :bodyStyle="{padding: '12px 24px'}">
              <a-button
                :loading="loading"
                :type="type"
                @click="btnUpdateNotification">
                {{nameButonNotfication}}
              </a-button>
              <a-button
                :loading="loadingCertificado"
                type="primary"
                v-if="canGenerateCertificates"
                @click="generateCertificate()">
                Generar certificados
              </a-button>
            </a-card>
          </a-affix>
        </template>
        <span v-else>Seleccione una capacitación para ver más.</span>
      </a-tab-pane>
      <a-tab-pane tab="Calendario" key="2">
        <calendar v-if="rowSelected && rowSelected.id" :id_training="rowSelected && rowSelected.id"/>
        <span v-else>Seleccione una capacitación para ver más.</span>
      </a-tab-pane>
      <a-tab-pane tab="Objetivos estratégicos" key="3">
        <strategic-objectives v-if="rowSelected && rowSelected.id" :id_training="rowSelected && rowSelected.id"/>
        <span v-else>Seleccione una capacitación para ver más.</span>
      </a-tab-pane>
<!--      <a-tab-pane tab="Evaluación y asistencia" key="4">
        <competitor v-if="rowSelected && rowSelected.id" :id_training="rowSelected && rowSelected.id"/>
        <span v-else>Seleccione una capacitación para ver más.</span>
      </a-tab-pane>-->
      <a-tab-pane tab="Resumen por calificación" key="5">
        <notas-participantes v-if="rowSelected && rowSelected.id" :id_training="rowSelected && rowSelected.id"/>
        <span v-else>Seleccione para ver más.</span>
      </a-tab-pane>
      <a-tab-pane tab="Personas aprobadas" key="6">
        <personas-aprobadas v-if="rowSelected && rowSelected.id" :id_training="rowSelected && rowSelected.id"/>
        <span v-else>Seleccione para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    mounted () {
      this.httpClient = new HttpUtil()
    },
    data () {
      return {
        columnasCentroCosto: [
          {title: 'ID', dataIndex: 'id', sorter: true},
          {title: 'ID CC', dataIndex: 'cc_id', sorter: true},
          {title: 'Nombre CC', dataIndex: 'cc_name', sorter: true},
          {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_SEGMENTO'), dataIndex: 'segment_id', sorter: true},
          {title: 'Nombre Segmento', dataIndex: 'segment_name', sorter: true},
          {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_UNIDAD'), dataIndex: 'unit_id', sorter: true},
          {title: 'Nombre Unidad', dataIndex: 'unit_name', sorter: true},
          {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_PROYECTO'), dataIndex: 'prj_id', sorter: true},
          {title: 'Nombre Proyecto', dataIndex: 'prj_name', sorter: true}
        ],
        categorias: {h_lookup_type: 'TRN_CATEGORIAS'},
        herramientas: {h_lookup_type: 'TRN_HERRAMIENTAS'},
        tipo_capacitador: {h_lookup_type: 'TRN_TIPO_CAPACITADOR'},
        master: {
          endpoint: 'training',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '30', '40', '50'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            actions: {
              width: 130,
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'}
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'}
                },
                {
                  name: 'generar_certificado',
                  text: 'Generar certificado',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'snippets', style: 'color: red'},
                  fnLoading: (record) => this.loadingBtns[record.id] === record.id,
                  fnVisible: (record) => record.status === 'CERRADA'
                },
                {
                  name: 'notification',
                  text: 'Activar notificaciones',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'mail', style: 'color: red'},
                  fnVisible: (record) => {
                    return !record.notification
                  }
                },
                {
                  name: 'no_notificar',
                  text: 'Desactivar notificaciones',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'close-square', style: 'color: red'},
                  fnVisible: (record) => {
                    return record.notification
                  }
                }
              ]
            },
            columns: [
              {title: 'Nombre', dataIndex: 'name', sorter: true},
              {title: 'Capacidad', dataIndex: 'capacity', sorter: true},
              {title: 'Solicitado por', dataIndex: 'full_name_requested_by', sorter: true},
              {title: 'Fecha solicitud', dataIndex: 'request_date_desc', sorter: true},
              {title: 'Centro de costo', dataIndex: 'cc', sorter: true},
              {title: 'Objetivos', dataIndex: 'objectives', sorter: true},
              {title: 'Observación', dataIndex: 'observation', sorter: true},
              {title: 'Total días', dataIndex: 'total_days', sorter: true},
              {title: 'Horas totales', dataIndex: 'total_hours', sorter: true},
              {title: 'Fecha inicio', dataIndex: 'init_date_desc', sorter: true},
              {title: 'Fecha fin', dataIndex: 'end_date_desc', sorter: true},
              {title: 'Hora inicio', dataIndex: 'start_time_desc', sorter: true},
              {title: 'Hora fin', dataIndex: 'end_time_desc', sorter: true},
              {title: 'Fecha vencimiento', dataIndex: 'expiration_date_desc', sorter: true},
              {title: 'Tipo de asistencia', dataIndex: 'assistence_type_desc', sorter: true},
              {title: 'Modalidad', dataIndex: 'modality', sorter: true},
              {title: 'Prioridad', dataIndex: 'priority', sorter: true},
              {title: 'Lugar', dataIndex: 'place', sorter: true},
              {title: 'Requerimientos', dataIndex: 'requirements', sorter: true},
              {title: 'URL', dataIndex: 'url', sorter: true},
              {title: 'Nota aprobatoria', dataIndex: 'passing_note', sorter: true},
              {title: 'Asistencia aprobatoria', dataIndex: 'passing_assistance', sorter: true}
            ]
          }
        },
        colOptions: {xs: 24, sm: 8},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        loadingBtns: {},
        training_type: {
          h_lookup_type: 'TRN_TIPO_DE_CAPACITACION'
        },
        assistence_type: {
          h_lookup_type: 'TRN_TIPO_DE_ASISTENCIA'
        },
        valoresExpandidos: [
          {label: 'Nombre', column: 'name'},
          {label: 'Capacidad', column: 'capacity'},
          {label: 'Solicitado por', column: 'full_name_requested_by'},
          {label: 'Fecha solicitud', column: 'request_date_desc'},
          {label: 'Centro de costo', column: 'cc'},
          {label: 'Objetivos', column: 'objectives'},
          {label: 'Observación', column: 'observation'},
          {label: 'Total días', column: 'total_days'},
          {label: 'Horas totales', column: 'total_hours'},
          {label: 'Fecha inicio', column: 'init_date_desc'},
          {label: 'Fecha fin', column: 'end_date_desc'},
          {label: 'Hora inicio', column: 'start_time_desc'},
          {label: 'Hora fin', column: 'end_time_desc'},
          {label: 'Fecha vencimiento', column: 'expiration_date_desc'},
          {label: 'Tipo de capacitación', column: 'training_type_desc'},
          {label: 'Tipo de asistencia', column: 'assistence_type_desc'},
          {label: 'Modalidad', column: 'modality'},
          {label: 'Prioridad', column: 'priority'},
          {label: 'Lugar', column: 'place'},
          {label: 'Requerimientos', column: 'requirements'},
          {label: 'URL', column: 'url'},
          {label: 'Nota aprobatoria', column: 'passing_note'},
          {label: 'Asistencia aprobatoria', column: 'passing_assistance'}
        ],
        type: 'primary',
        loading: false,
        loadingCertificado: false,
        capacitorType: {}
      }
    },
    props: ['id_course'],
    methods: {
      modeloRecibido (value) {
        this.$refs.master.modal.form.setFieldsValue({
          id_cc: value
        })
      },
      masterActions (action) {
        switch (action.action) {
          case 'masterEdit':
            this.$nextTick(() => {
              if (!this.$isEmpty(action.record.requested_by)) {
                this.$refs.requested_by && this.$refs.requested_by.handleSearch(action.record.requested_by)
              }
              if (!this.$isEmpty(action.record.id_h_trainer_type)) {
                this.$refs.tipo_capacitador && this.$refs.tipo_capacitador.handleChange(action.record.id_h_trainer_type)
              }
              if (!this.$isEmpty(action.record.trainer)) {
                this.$refs.capacitador && this.$refs.capacitador.handleSearch(action.record.trainer)
              }
            })
            break
          case 'generar_certificado':
            this.loadingBtns[action.record.id] = action.record.id
            this.loadingBtns = Object.assign({}, this.loadingBtns)
            this.generateCertificate(action.record.id)
            break
          case 'notification':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea notificar los participantes inscriptos en esta capacitación?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.updateNotification(true, action.record.id, resolve, reject)
                })
              },
              onCancel () {}
            })
            break
          case 'no_notificar':
            this.$confirm({
              title: 'Confirmación',
              content: '¿Está seguro que desea desactivar las notificaciones a esta capacitación?',
              onOk: () => {
                return new Promise((resolve, reject) => {
                  this.updateNotification(false, action.record.id, resolve, reject)
                })
              },
              onCancel () {}
            })
            break
        }
      },
      generateCertificate (id = null) {
        this.loadingCertificado = true
        if (this.$isEmpty(id)) {
          id = this.rowSelected.id
        }
        this.httpClient.getInstance().get('generar_certificados', {params: {training_id: id}}).then(response => {
          Mensajes.success(response.data.message)
        }).catch(error => {
          Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible generar los certificados, contacte al administrador.'))
        }).then(() => {
          delete this.loadingBtns[id]
          this.loadingBtns = Object.assign({}, this.loadingBtns)
          this.loadingCertificado = false
        })
      },
      btnUpdateNotification () {
        let status = this.type === 'primary'
        return new Promise((resolve, reject) => {
          this.updateNotification(status, this.rowSelected.id, resolve, reject)
        })
      },
      updateNotification (notification, id, resolve, reject) {
        this.loading = true
        this.httpClient.getInstance().put(this.master.endpoint + '/' + id, {
          notification: notification
        })
          .then(() => {
            this.$refs.master.$refs.datatable.loadData()
            resolve()
          })
          .catch((error) => {
            Mensajes.error('Error', 'No fue posible activar o desactivar las notificaciones')
            reject(error)
            this.loading = false
          }).then(() => {
            this.loading = false
          })
      }
    },
    computed: {
      parentData () {
        return {
          id_course: this.id_course
        }
      },
      rowSelected () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0] : null
      },
      nameButonNotfication () {
        let strStatus = 'Activar Notificación'
        this.type = 'primary'
        if (this.rowSelected && this.rowSelected.notification) {
          strStatus = 'Desactivar Notificación'
          this.type = 'danger'
        }
        return strStatus
      },
      canGenerateCertificates () {
        return this.rowSelected.status === 'CERRADA'
      },
      isInternal () {
        let result = false
        if (this.capacitorType.hasOwnProperty('text')) {
          result = this.capacitorType['text'] === 'INTERNO'
        }
        if (!result) {
          this.$refs.master && this.$refs.master.modal.form.setFieldsValue({
            trainer: null
          })
        } else {
          this.$refs.master && this.$refs.master.modal.form.setFieldsValue({
            externa_trainer_id_person: null,
            external_trainer_name: null,
            external_trainer_email: null
          })
        }
        return result
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Capacitaciones/Training.vue